import { RegistroSalidaModalComponent } from './registro-salida-modal.component';
import { RegistroSalidaVisitanteRoutingModule } from './registro-salida-visitante-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../../shared/shared.module';
import { RegistroSalidaVisitanteComponent } from './registro-salida-visitante.component';

@NgModule({
    declarations: [RegistroSalidaVisitanteComponent, RegistroSalidaModalComponent],
    imports: [
        RegistroSalidaVisitanteRoutingModule,
        SharedModule,
        CommonModule
    ],
    entryComponents: [RegistroSalidaModalComponent]
})
export class RegistroSalidaVisitanteModule { }
